import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";

const API_URL = process.env.BFF_URL

class DoctorService {

  create(mid, doctor) {
    return http.post(API_URL + `/v1/merchants/${mid}/doctors`, doctor, { headers: authHeader() });
  }

  update(mid, id, doctor) {
    return http.put(API_URL + `/v1/merchants/${mid}/doctors/${id}`, doctor, { headers: authHeader() });
  }

  delete(mid, id) {
    return http.delete(API_URL + `/v1/merchants/${mid}/doctors/${id}`, { headers: authHeader() });
  }

  find(mid, params) {
    return http.get(API_URL + `/v1/doctors`, { params: params, headers: authHeader() });
  }

  findByBusinessId(businessId, params) {
    const queryParams = { ...params, businessId };
    return http.get(API_URL + `/v1/doctors`, { params: queryParams, headers: authHeader() });
  }

  findById(mid, id) {
    return http.get(API_URL + `/v1/doctors/${id}`, { headers: authHeader() });
  }

  handleResponse(response) {
    return response
  }
}

export default new DoctorService();



// WEBPACK FOOTER //
// ./src/service/doctor.service.js